// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-p-label{display:inline-flex;align-items:center;justify-content:center}.beeract-title-beer{width:.85333rem;height:.85333rem;margin:0 .10667rem}.beeract-tips-beer{width:.53333rem;height:.53333rem;margin:0 .16rem}.beeract-histit-beer{width:.8rem;height:.8rem;margin:0 .16rem}.beer-van-dia{width:8.4rem}", ""]);
// Exports
module.exports = exports;
